import { Divider, type DividerProps, useTheme } from "@mui/material";

export const BaseDivider = ({ sx, orientation, ...rest }: DividerProps) => {
  const theme = useTheme();
  return (
    <Divider
      sx={{
        ...sx,
        borderWidth: "1px",
        borderImage: `repeating-linear-gradient(to ${orientation === "vertical" ? "bottom" : "right"}, ${theme.palette.grey[500]} 0, ${theme.palette.grey[500]} 4px, transparent 0, transparent 12px) 1`, // "#66736FFF" = grey.500
      }}
      {...rest}
    />
  );
};
